import { render } from "./ResourceLink.vue?vue&type=template&id=10a936ec"
import script from "./ResourceLink.vue?vue&type=script&lang=js"
export * from "./ResourceLink.vue?vue&type=script&lang=js"

import "./ResourceLink.vue?vue&type=style&index=0&id=10a936ec&lang=scss&rel=scss%2Fstylesheet"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__